import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';

import SignupButton from '../buttons/SignupButton';

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const MobileMenu = ({ isOpen, onClick }) => (
  <div className={`MobileMenu ${isOpen ? 'MobileMenu--isOpen' : ''}`}>
    <div className="MobileMenu__inner">
      <ul className="MobileMenu__list">
        <li className="MobileMenu__item">
          <Link
            className="btn btn-link MobileMenu__link"
            to="/pricing"
            onClick={onClick}
          >
            Pricing
          </Link>
        </li>

        <li className="MobileMenu__item">
          <a
            href="https://app.radoneasy.com/login"
            className="btn btn-link MobileMenu__link"
          >
            Login
          </a>
        </li>

        <li className="MobileMenu__item">
          <SignupButton className="btn btn-success MobileMenu__link" />
        </li>

        <li className="MobileMenu__item">
          <Link
            className="btn btn-outline-success MobileMenu__link"
            to="/demo-request"
            onClick={onClick}
          >
            Book a Demo
          </Link>
        </li>
      </ul>
    </div>
  </div>
);

MobileMenu.propTypes = propTypes;

export default MobileMenu;



// WEBPACK FOOTER //
// ./src/components/MobileMenu/MobileMenu.js